const formSim = {
	el: {
		formSim: document.querySelector('.js-form-simulator'),
		btnsNavigateSection: document.querySelectorAll('.js-navigate-section'),
		btnsValidateSection: document.querySelectorAll('.js-validate-section'),
		navigationContainer: document.querySelector('.js-steps')
	},

	fxSetSectionContainerHeight (section, scrollToTop = true) {
		const sectionHeight = section.offsetHeight,
			sectionContainer = section.parentElement

		//console.log(section.dataset.section, section.offsetHeight)
		sectionContainer.style.height = `${sectionHeight}px`

		if(scrollToTop) {
			$('html, body').animate({ 
				scrollTop: $('.navigation').offset().top
			}, 50)
		}
	},

	fxToggleIgnore (section, removeClass = true) {
		const inputs = [...(section.querySelectorAll('.form__input')), ...(section.querySelectorAll('.form__input-select')), ...(section.querySelectorAll('.form__input-radio'))]
	
		//remove ignore class on required fields to validate section
		for(const input of inputs) {
			if(removeClass) {
				input.hasAttribute('required') && input.classList.remove('js-ignore')
			} else {
				if (input.hasAttribute('required') && !input.classList.contains('js-ignore'))
					input.classList.add('js-ignore')
			}
		}
	},

	fxNavigateToSection(el, sectionId) {
		const sectionContainer = this.el.formSim.querySelector('.form__section-container'),
			sections = sectionContainer.querySelectorAll('.form__section'),
			steps = this.el.navigationContainer.querySelectorAll('.simulator__steps-step')

		//go to next step
		if(el.classList.contains('js-validate-section')) {
			if(this.fxValidateSection(sections[Number(sectionId) - 2])) {
				//toggle js-ignore class for validation on next section
				this.fxToggleIgnore(sections[Number(sectionId) - 1])
				//slide to section
				sectionContainer.dataset.sectionActive = sectionId

				//update steps
				for (const step of steps) {
					step.innerHTML === sectionId ? step.classList.add('active') : step.classList.remove('active')
				}
			}
		//go to previous step
		} else {
			//toggle js-ignore class for validation
			this.fxToggleIgnore(sections[Number(sectionId)], false)
			sectionContainer.dataset.sectionActive = sectionId

			for (const step of steps) {
				step.innerHTML === sectionId ? step.classList.add('active') : step.classList.remove('active')
			}

			//set height of previous section
			this.fxSetSectionContainerHeight(sections[Number(sectionId) - 1])
		}
	},

	fxValidateSection (section) {
		const $form = $(section.closest('.js-form-simulator')),
			$this = this

		//-override default validator messages
		$.validator.messages = {
			...$.validator.messages,
			required: $form.data('msg-required')
		}

		$form.validate({
			focusInvalid: false,
			ignore: '.js-ignore',
			errorClass: 'error',
			invalidHandler (form, validator) {
				if (!validator.numberOfInvalids()) return
		
				const header = document.querySelector('.header'),
					headerHeight = header.classList.contains('sticky') ? header.offsetHeight + 50 : 50
				$('html, body').animate({
					scrollTop: $(validator.errorList[0].element.closest('.form__field')).offset().top - headerHeight
				}, 50)
			},
			errorPlacement(error, element) {
				element.hasClass('form__input-radio') ? error.insertAfter(element.closest('.form__field-inner')) : error.insertAfter(element)
			},
			highlight(element, errorClass, validClass) {
				$(element).closest('.form__field').addClass(errorClass).removeClass(validClass)
				$this.fxSetSectionContainerHeight(section, false)
			},
			unhighlight(element, errorClass, validClass) {
				$(element).closest('.form__field').addClass(validClass).removeClass(errorClass)
				$this.fxSetSectionContainerHeight(section, false)
			}
		})

		if($form.valid()) {
			setTimeout(() => {
				//console.log('validation true')
				this.fxSetSectionContainerHeight(section.nextElementSibling, true)
			}, 50)
		} else {
			setTimeout(() => {
				//console.log('validation false')
				this.fxSetSectionContainerHeight(section, false)
			}, 50)
		}

		return $form.valid()
	},

	events () {
		for(const btn of this.el.btnsNavigateSection) {
			btn.addEventListener('click', e => {
				this.fxNavigateToSection(e.currentTarget, e.currentTarget.dataset.navigateSection)
			})
		}

		//show loader after form submission
		this.el.formSim.addEventListener('submit', e => {
			formHelper.fxShowLoader(e.currentTarget)
		})
	},

	init () {
		if(!this.el.formSim) return
		formValidation.fxValidations($(this.el.formSim))
		this.events()
	}
}

formSim.init()